import { Component, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Account } from "src/app/auth/auth.model";
import { AccountsApiService } from "../../api/accounts-api.service";
import { Router } from "@angular/router";
import { LanguagePickerService } from "src/app/utils/language-picker/language-picker.service";
import { MessageService } from "../../utils/message/message.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'app-apex-account-super-admin',
  templateUrl: './apex-account-super-admin.component.html',
  styleUrls: ['./apex-account-super-admin.component.scss']
})
export class ApexAccountSuperAdminComponent {

  items: any;
  originalItems: Account[];
  filteredItems: Account[];

  displayedColumns: string[] = ['customerName', 'customerNumber', 'zip', 'apex', 'beta'];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('userPaginator') userPaginator: MatPaginator;

  customerNumberSearch: string;

  constructor(
    private accountsApi: AccountsApiService,
    private router: Router,
    private languagePickerService: LanguagePickerService,
    private messageService: MessageService,
    private translate: TranslateService,
  ) {
    this.fetch();
  }

  fetch() {
    this.accountsApi.getAll().subscribe(items => {
      this.originalItems = this.filteredItems = items;
      this.items = new MatTableDataSource(items);
      this.items.sort = this.sort;
      this.items.paginator = this.userPaginator;
    });
  }

  sortData(sort: Sort) {
    const data = this.filteredItems.slice();

    if (!sort.active || sort.direction === '') {
      this.filteredItems = data;
      return;
    }

    this.filteredItems = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'customerNumber': return compare(a.customerNumber, b.customerNumber, isAsc);
        case 'customerName':   return compare(a.customerName, b.customerName, isAsc);
        case 'zip':            return compare(a.zip, b.zip, isAsc);
        default: return 0;
      }
    });
    this.items = new MatTableDataSource(this.filteredItems);
    this.reInitTableSortPaginator();
  }

  toggleApex(row: Account) {
    const newValue = !row.apex;
    this.accountsApi.setApex(row.id, newValue).subscribe(response => {
      if (!response || response.success) {
        row.apex = newValue;
        const key = newValue ? 'admin.apex.messages.apexEnabled' : 'admin.apex.messages.apexDisabled';
        this.messageService.info(this.translate.instant(key, { customerName: row.customerName }));
      } else {
        this.messageService.error(this.translate.instant('admin.apex.messages.apexError'));
      }
    });
  }

  toggleBeta(row: Account) {
    const newValue = !row.beta;
    this.accountsApi.setBeta(row.id, newValue).subscribe(response => {
      if (!response || response.success) {
        row.beta = newValue;
        const key = newValue ? 'admin.apex.messages.betaEnabled' : 'admin.apex.messages.betaDisabled';
        this.messageService.info(this.translate.instant(key, { customerName: row.customerName }));
      } else {
        this.messageService.error(this.translate.instant('admin.apex.messages.betaError'));
      }
    });
  }

  search() {
    if (this.customerNumberSearch === '') {
      this.filteredItems = this.originalItems;
    } else {
      this.filteredItems = this.originalItems.filter(item => item.customerNumber === this.customerNumberSearch);
    }
    this.items = new MatTableDataSource(this.filteredItems);
    this.reInitTableSortPaginator();
  }

  private reInitTableSortPaginator() {
    this.items.sort = this.sort;
    this.items.paginator = this.userPaginator;
  }

  goBack() {
    this.router.navigate(['/sa/home']);
  }

  isEnglish(): boolean {
    return this.languagePickerService.getLanguageCode() === 'en';
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
